import { vModelText as _vModelText, createVNode as _createVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8de0dbd6")

_pushScopeId("data-v-8de0dbd6")
const _hoisted_1 = { class: "absolute bottom-14 left-0 w-full" }
const _hoisted_2 = { class: "bg-white rounded-lg drop-shadow-md triangle mx-4 p-4" }
const _hoisted_3 = {
  key: 0,
  class: "h-64 flex flex-col items-center justify-center py-8"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "text-gray-500 text-sm" }, "取得中...", -1)
const _hoisted_5 = {
  key: 1,
  class: "h-64 flex justify-start items-start flex-col flex-wrap overflow-x-scroll"
}
const _hoisted_6 = { class: "text-right" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_m_loading_icon = _resolveComponent("m-loading-icon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _withDirectives(_createVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchKeyword = $event)),
        type: "search",
        name: "search",
        placeholder: "絞り込み...",
        class: "w-full bg-primary-100 rounded-md border border-white focus:border-primary-500 text-base outline-none text-gray-700 py-1 px-3 mb-4 leading-8 transition-colors duration-300"
      }, null, 512), [
        [_vModelText, _ctx.searchKeyword]
      ]),
      (_ctx.load)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode(_component_m_loading_icon),
            _hoisted_4
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_5, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filteredStickers, (sticker) => {
              return (_openBlock(), _createBlock("div", {
                key: sticker.ref.id
              }, [
                _createVNode("input", {
                  id: sticker.ref.id,
                  type: "radio",
                  name: "check-stamp",
                  class: "hidden"
                }, null, 8, ["id"]),
                _createVNode("label", {
                  for: sticker.ref.id
                }, [
                  _createVNode("img", {
                    src: sticker.data.imageUrl,
                    alt: "Arrow",
                    class: "h-28 mb-4 mr-4 rounded-md border-2 border-gray-200 cursor-pointer",
                    onClick: ($event: any) => (_ctx.selectSticker(sticker.ref.id))
                  }, null, 8, ["src", "onClick"])
                ], 8, ["for"])
              ]))
            }), 128))
          ])),
      _createVNode("div", _hoisted_6, [
        _createVNode("button", {
          class: ["flex-shrink-0 rounded-md font-medium px-4 py-2 text-white focus:outline-none transition-all duration-300 right-full", _ctx.dynamicButtonCss],
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.sendSticker && _ctx.sendSticker(...args)))
        }, " 送る ", 2)
      ])
    ])
  ]))
})